/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		module.children = [];
		Object.defineProperty(module, "exports", {
			enumerable: true,
			configurable: false,
			get: function() { return module.e; },
			set: function(v) { return module.e = v; }
		});
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			configurable: false,
			get: function() { return module.l; }
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			configurable: false,
			get: function() { return module.i; }
		});
		module.webpackPolyfill = 1;
	}
	return module;
}




/*****************
 ** WEBPACK FOOTER
 ** (webpack)/buildin/module.js
 ** module id = 1737
 ** module chunks = 0
 **/